<template>
  <b-row align-v="start" class="px-1" no-gutters>
    <b-col class="ml-2" cols="9">
      <h3 v-testid="'sidebar-tracker-subscription-name-message'" class="m-0 product-name mb-1">
        <template v-if="productName">
          {{ productName }}
        </template>
        <template v-else>{{ petTrackingDeviceName }} {{ $t('dp.generic.subscription') }}</template>
      </h3>

      <div v-testid="'sidebar-tracker-subscription-interval-message'">{{ subscriptionIntervalCount }} {{ subscriptionInterval }}</div>
      <div v-if="productDescription" v-html="productDescription"></div>
    </b-col>
    <b-col>
      <h3 class="m-0 text-right">
        <span>
          {{ productPrice }}
        </span>
      </h3>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'PetTrackingDeviceSubscriptionProduct',
  props: {
    productName: {
      type: String,
      required: false,
      default: null
    },
    productDescription: {
      type: String,
      required: false,
      default: null,
    },
    productPrice: {
      type: String,
      required: true,
    },
    subscriptionInterval: {
      type: String,
      required: false,
      default: null,
    },
    subscriptionIntervalCount: {
      type: Number,
      required: false,
      default: null,
    },
  },
  computed: {
    petTrackingDeviceName() {
      return this.$store.getters['petOwner/getPetTrackingDeviceName'];
    },
  }
};
</script>

<style lang="scss" scoped>
</style>